import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import PageHeader from '../components/PageHeader'
import TableroAsignaciones from '../components/capsulas/TableroAsignaciones'
import ReportesCapsulas from '../components/capsulas/ReportesCapsulas'
import HorarioLaboral from '../components/capsulas/HorarioLaboral'

const VISTAS = ['tablero', 'reportes', 'horario']

// Mantenimiento > Asignaciones: who works on which parte (work capsules).
// The view lives in the address (?vista=) so a report can be linked.
export default function Asignaciones() {
  const { t } = useTranslation('engineering')
  const [sp, setSp] = useSearchParams()
  const vista = VISTAS.includes(sp.get('vista')) ? sp.get('vista') : 'tablero'
  return (
    <div className="p-8">
      <div className="mb-6">
        <PageHeader title={t('capsulas.titulo')} subtitle={t('capsulas.subtitulo')} />
      </div>
      <div className="inline-flex rounded-lg border border-gray-200 bg-white p-0.5 mb-5">
        {VISTAS.map(v => (
          <button key={v} type="button" onClick={() => setSp(v === 'tablero' ? {} : { vista: v })}
            className={`px-3.5 py-1.5 rounded-md text-sm font-medium transition-colors ${
              vista === v ? 'bg-gray-900 text-white' : 'text-gray-500 hover:text-gray-900'}`}>
            {t(`capsulas.vistas.${v}`)}
          </button>
        ))}
      </div>
      {vista === 'tablero' && <TableroAsignaciones />}
      {vista === 'reportes' && <ReportesCapsulas />}
      {vista === 'horario' && <HorarioLaboral />}
    </div>
  )
}
